export const ASSISTANT_STOP_WORDS = new Set([
  'el',
  'la',
  'los',
  'las',
  'un',
  'una',
  'de',
  'del',
  'al',
  'en',
  'y',
  'o',
  'a',
  'que',
  'qué',
  'con',
  'sin',
  'por',
  'para',
  'eso',
  'esa',
  'ese',
  'somos',
  'como',
  'cuando',
  'cuándo',
  'mas',
  'más',
  'muy',
  'todo',
  'tienen',
  'tiene',
  'tengo',
  'hay',
  'quiero',
  'saber',
  'duda',
  'pregunta',
  'puede',
  'puedo',
  'podemos',
  'algo',
  'alguna',
  'algun',
  'algún',
  'este',
  'esta',
  'estos',
  'estas',
  'eso',
  'dan',
  'das',
  'hacen',
  'hace',
  'venden',
  'vende',
  'son',
  'las',
  'los',
]);

function stripAccents(s) {
  return String(s || '')
    .normalize('NFD')
    .replace(/\p{M}/gu, '');
}

export function normalizeAssistantText(s) {
  return stripAccents(String(s || '').toLowerCase());
}

export function inferServicePreferenceFromText(n) {
  const pickup =
    /\b(retiro|para\s+retiro|paso\s+a\s+buscar|pasar\s+a\s+buscar|voy\s+al\s+local|para\s+llevar|take\s*away|pick\s*up|lo\s+paso\s+a\s+buscar|lo\s+retiro)\b/.test(
      n
    );
  const delivery =
    /\b(delivery|domicilio|a\s+domicilio|envio|envío|reparto|motorizado|en\s+moto|que\s+(te\s+)?llegue|quiero\s+que\s+llegue|llegue\s+a\s+tiempo|llegue\s+a\s+la\s+hora|a\s+mi\s+casa|para\s+la\s+casa)\b/.test(
      n
    ) || /\b(me\s+lo\s+traen|traigan|manden\s+a|a\s+casa|manda\s+a\s+mi\s+casa)\b/.test(n);
  if (pickup && !delivery) return 'pickup';
  if (delivery && !pickup) return 'delivery';
  if (pickup && delivery) {
    return /\b(retiro|paso\s+a\s+buscar|para\s+llevar|para\s+retiro)\b/.test(n) ? 'pickup' : 'delivery';
  }
  return null;
}

export function tokenizeQuery(raw) {
  return normalizeAssistantText(raw)
    .split(/[^a-z0-9ñ]+/)
    .filter((w) => w.length > 2 && !ASSISTANT_STOP_WORDS.has(w));
}

